module.exports = __webpack_public_path__ + "static/url-shortner-5ed26f902237538e9fb84ea9a61fff90.png";